import {Component, Inject, OnInit} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {FormsModule, UntypedFormControl} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';

import { AssetService } from '../../../services/assets.service';
//import { Asset } from 'app/models/Asset';

import { debounceTime,distinctUntilChanged,switchMap,filter, tap } from 'rxjs/operators'
import { Observable } from 'rxjs';
import { Product } from 'app/models/Product';

@Component({
  selector: 'assignStockPopup',
  templateUrl: './assignStockPopup.component.html',
  styleUrls: ['./assignStockPopup.component.css']
})
export class assignStockPopupComponent implements OnInit {

  public products: Array<Product> = [];
  public queryField: UntypedFormControl = new UntypedFormControl();

  public selectedStock: Product = null;

  constructor(
    private _assetService: AssetService,
    public dialogRef: MatDialogRef<assignStockPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  ngOnInit() {
    const queryPipe = this.queryField.valueChanges
    .pipe(debounceTime(500))
    .pipe(distinctUntilChanged())

    const apiCallPipe = queryPipe
    .pipe(filter(query => query.length >= 3))
    .pipe(switchMap( query => this._assetService.getProductsStock("",query,"",1) ) )
    .subscribe((result: any) =>
      {
        this.products = result.products;
      });
    
    // If length is less than 4, clear assets list
    const clearPipe = queryPipe
    .pipe(filter(query => query.length < 3))
    .subscribe( query => this.products = []);
  }

  onClickSelectStock(stock: Product){
    this.data.stock = stock.sku;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

export interface DialogData {
  unit: string;
  stock: string;
}
